import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing } = theme.busbud;

  return {
    backdrop: {
      background: colors.background.primary.translucent,
      position: "absolute",
      inset: 0,
      zIndex: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    termsAndCondition: {
      margin: spacing(0, 5)
    },
    optin: {
      alignSelf: "center",
      color: colors.text.secondary.opaque
    }
  };
});
